import { styled } from 'styled-components';
import { Card } from 'antd';

export const SCard = styled(Card)`
  flex: 1;
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 360px;
  background-color: #fff;

  & .ant-card-body {
    padding: 24px;
    min-width: 560px;
    min-height: 360px;
    height: 100%;
    display: flex;
    flex-direction: column;
  }
`;
